// const subjects = [
//   "Contemporary Philippine Arts from the Regions",
//   "Web Development",
//   "General Chemistry",
//   "Capstone",
//   "Work Immersion",
//   "MTEC",
//   "Physical Education",
//   "General Physics",
// ];

// const subjectsShort = [
//   "CPAR",
//   "WEB DEV",
//   "GEN CHEM",
//   "CAPSTONE",
//   "IMMERSION",
//   "MTEC",
//   "PE",
//   "GEN PHYS",
// ];

const subjects = [
  "Contemporary Philippine Arts from the Regions",
  "AutoCad 2",
  "General Chemistry 2",
  "RESEARCH",
  "Work Immersion",
  "Empowerment Technology",
  "Physical Education 4",
  "General Physics 2",
  "Web Development",
];

const subjectsShort = [
  "CPAR",
  "AUTOCAD 2",
  "GEN CHEM 2",
  "RESEARCH",
  "IMMERSION",
  "MTEC",
  "PE 4",
  "GEN PHYS 2",
  "WEB DEV",
];

const sections = ["E1", "E5", "E7", "E11"];

const driveFolderId = [
  "1EiVUMvYMwpMBtH5j_zFa-Crx4urk0Rqo",
  "1zrlriXAfNhnd_q0neaq7rTlN2eNq7HMh",
  "1jmnr3CcnfZ5JWYqSmXG5w4VSZtEo9Vwr",
  "1pCbO_Frgh2oE4ckLaUcDdNCmX-uH5bq9",
  "11B_6VUZoWu6aS1GWCio9wqNF8tSUGo_J",
  "1SNL_MiCeM6HKjLM2opZGs982ixTFyRkY",
  "18CA64ewfuoYkELWHC4Q7M6kZA1g9kEJk",
  "16EhnGp0GzYtZ9h5K-ToVoFXYbxuE2HV-",
  "1vl9wUweFJ-I0l2hTzQaSLK5_u6l9jE1K",
];

export { subjects, sections, driveFolderId, subjectsShort };
